import * as Event from '../../events';
import CategoryModel from '../../model/category-model';

/**
 * Administrator - Product
 * 
 * @author wadahkode <mvp.dedefilaras@gmail.com>
 * @since version v1.0.85
 */
class Category extends CategoryModel {
    constructor(table) {
        super(table);
        this.category = [];
    }
    
    create() {
        let form = document.getElementById('form-create-category');
        Event.tags(form.categoryName);
        
        Event.onClick(form.querySelector('.quick-btn-create-category'), response => {
            response.disabled = true;
            response.innerHTML = `
                <span class="spinner"></span>
                <span class="uk-margin-small-left">Please wait...</span>
            `;
            form.onsubmit = this.handleCategory(form,response);
        });
    }
    
    handleCategory(form,btn) {
        var input = Array.prototype.forEach.call(form.querySelectorAll('.category-input'), (input,key) => {
            return this.columns.push({
                "id": key,
                "name": input.value
            });
        });
        
        this.setUp();
        
        setTimeout(function() {
            btn.disabled = false;
            btn.innerHTML = "tambah";
        }, 3000);
        
    }
    
    index() {
        let catContainer = document.getElementById('view-category'),
            viewCat = `<thead>
                <th>#</th>
                <th>Nama kategori</th>
                <th>aksi</th>
            </thead>`;
        
        this.ref.on('value', snapshot => {
            snapshot.forEach(item => {
                viewCat += this.createViewCategory(item.val());
            });
            
            catContainer.innerHTML = viewCat;
        });
    }
    
    createViewCategory(item) {
        return `
            <tbody>
                <td>${item.id + 1}</td>
                <td>${item.name}</td>
                <td>
                    <button type="button" class="uk-button uk-button-small uk-button-primary">edit</button>
                    <button type="button" class="uk-button uk-button-small uk-button-danger">hapus</button>
                </td>
            </tbody>
        `;
    }
}

export default Category;